<template src="@/components/Ork/OrkHelloBar.html"></template>
<style lang="scss" scoped src="@/components/Ork/OrkHelloBar.scss"></style>

<script>
import { SfButton } from '@storefront-ui/vue';
import { Navigation, Pagination, EffectFade } from 'swiper'
import { SwiperCore, Swiper, SwiperSlide } from 'swiper-vue2'
import "swiper/swiper-bundle.css";
SwiperCore.use([Navigation, Pagination, EffectFade])

// This is how we should import once we are in Vue3 and can use a more recent version of swiper
// import {Swiper as SwiperCore} from 'swiper'
// import {Navigation, Pagination, EffectFade} from 'swiper'
// import {Swiper, SwiperSlide} from 'swiper/vue'
// import "swiper/swiper-bundle.css";
// SwiperCore.use([Navigation, Pagination, EffectFade])

import Api from "@/api/Api";
import { configuration } from '@/config/InstanceConfiguration';


export default {
  name: 'OrkHelloBar',
  components: {
    SfButton,
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      error: false,
      errorMesage: null,
      loading: true,
      topBannerItems: []
    };
  },
  computed: {
    locale() { return this.$i18n.locale },
    dateNow() { return new Date() },
    showTopBanner() { return configuration.header.topBanner.enabled && this.topBannerItems.length }
  },

  created() {
    this.getTopBannerItems()
  },

  methods: {
    async getTopBannerItems() {
      this.loading = true

      let promoItems = []
      try {
        promoItems = configuration.header.topBanner.showPromoItems ? await Api.marketing.getTopPromotional() : []
      } finally {
        this.loading = false
      }

      this.topBannerItems = [...configuration.header.topBanner.staticItems, ...promoItems]
    }
  }
};
</script>